import React from "react";

function About (){
    return(
        <>
            <div>
                <div className="bg-white py-16 px-4">
                    <div className="max-w-6xl mx-auto text-center">
                        <h1 className="text-5xl font-bold text-gray-900 font-heading mb-6">Child Care Legal Aid
                            Clinic</h1>
                        <h2 className="text-4xl font-bold text-orange-900 font-heading mb-4">CHICALAC</h2>
                        <p className="font-semibold text-gray-600 text-xl max-w-3xl mx-auto">Advocating for the welfare
                            of children and dedicated to the protection, provision, legal aid, and enhancement of
                            children's rights through court representation.</p>
                    </div>
                </div>
                <div className="py-16 px-4 bg-gray-100">
                    <div className="max-w-6xl mx-auto">
                        <div className="flex flex-col items-center">

                            <div className="flex flex-col items-center text-center px-6 py-12 bg-white">
                                <h4 className="text-4xl font-bold text-gray-900 font-heading mb-6">Our Story</h4>

                                <p className="font-semibold text-gray-600 mb-5 max-w-3xl">
                                    Child Care Legal Aid Clinic (CHICALAC) was founded in 2010 and is duly registered by
                                    the Kenyan government as a non-governmental organization (NGO).
                                </p>

                                <p className="font-semibold text-gray-600 mb-5 max-w-3xl">
                                    Founded by Joseph Sawe and Advocate Kaira Nabasege, CHICALAC emerged as a critical
                                    response to the growing cases of child abuse, rising school dropouts at the primary
                                    level, and the lack of accessible legal support for underprivileged children. The
                                    founders envisioned a society where every child has the right to protection,
                                    education, and justice.
                                </p>

                                <p className="font-semibold text-gray-600 mb-5 max-w-3xl">
                                    CHICALAC is deeply committed to advocating for children’s welfare by providing legal
                                    aid, court representation, and community awareness. The organization also addresses
                                    systemic issues such as social injustice, corruption in child protection
                                    institutions, and widespread human rights violations that hinder the wellbeing and
                                    safety of vulnerable children.
                                </p>

                                <p className="font-semibold text-gray-600 mb-6 max-w-3xl">
                                    Through legal empowerment, civic education, and collaborative action with
                                    communities and policymakers, CHICALAC strives to create lasting change and uphold
                                    the dignity, safety, and rights of every child in Kenya.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="py-16 px-4 bg-white">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-12">
                            <h4 className="text-4xl font-bold text-gray-900 font-heading mb-4">Mission and Vision</h4>
                            <p className="font-semibold text-gray-600">Our guiding principles that drive our commitment
                                to children's rights</p>
                        </div>
                        <div className="grid md:grid-cols-2 gap-8">
                            <div className="bg-orange-50 p-8 rounded-lg shadow-lg">
                                <div className="text-center mb-6">

                                    <h5 className="text-2xl font-bold text-orange-900 font-heading">Our Mission</h5>
                                </div>
                                <p className="font-semibold text-gray-700 text-center text-lg">To empower the children
                                    to effectively access justice and enjoy their rights</p>
                            </div>
                            <div className="bg-gray-100 p-8 rounded-lg shadow-lg">
                                <div className="text-center mb-6">

                                    <h5 className="text-2xl font-bold text-gray-900 font-heading">Our Vision</h5>
                                </div>
                                <p className="font-semibold text-gray-700 text-center text-lg">A society of justice and
                                    equity for our children</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-16 px-4 bg-gray-100">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-12">
                            <h4 className="text-4xl font-bold text-gray-900 font-heading mb-4">What We Do</h4>
                            <p className="font-semibold text-gray-600 max-w-3xl mx-auto">We are dedicated to making a
                                meaningful impact in the lives of children through comprehensive legal aid and advocacy
                                services.</p>
                        </div>
                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                            <div className="bg-white p-6 rounded-lg shadow-lg text-center">

                                <h5 className="text-xl font-bold text-gray-900 font-heading mb-3">Child Protection</h5>
                                <p className="text-gray-600">Fighting against child abuse and ensuring the safety of
                                    vulnerable children.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-lg text-center">

                                <h5 className="text-xl font-bold text-gray-900 font-heading mb-3">Legal Aid</h5>
                                <p className="text-gray-600">Providing court representation and legal support for
                                    children's rights and other human rights.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-lg text-center">

                                <h5 className="text-xl font-bold text-gray-900 font-heading mb-3">Education Support</h5>
                                <p className="text-gray-600">Addressing high rates of school dropouts at primary
                                    education level.</p>
                            </div>
                            <div className="bg-white p-6 rounded-lg shadow-lg text-center">

                                <h5 className="text-xl font-bold text-gray-900 font-heading mb-3">Advocacy</h5>
                                <p className="text-gray-600">Championing children's welfare and rights enhancement
                                    initiatives.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-16 px-4 bg-white">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-12">
                            <h4 className="text-4xl font-bold text-gray-900 font-heading mb-4">Our Founders</h4>
                            <p className="font-semibold text-gray-600">Meet the visionary leaders who established
                                CHICALAC in 2010</p>
                        </div>
                        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                            <div className="bg-gray-50 p-8 rounded-lg shadow-lg text-center">
                                <img loading="lazy"  src="https://placehold.co/150x150" alt="Joseph Sawe"
                                     className="mx-auto mb-4 rounded-full"/>
                                <h5 className="text-2xl font-bold text-gray-900 font-heading mb-2">Joseph Sawe</h5>
                                <p className="font-semibold text-orange-900 mb-3">Co-Founder</p>
                                <p className="text-gray-600">Dedicated to intercepting increasing child abuse and making
                                    a difference in children's lives.</p>
                            </div>
                            <div className="bg-gray-50 p-8 rounded-lg shadow-lg text-center">
                                <img loading="lazy"  src="https://placehold.co/150x150" alt="Advocate Kaira Nabasege"
                                     className="mx-auto mb-4 rounded-full"/>
                                <h5 className="text-2xl font-bold text-gray-900 font-heading mb-2">Advocate Kaira
                                    Nabasege</h5>
                                <p className="font-semibold text-orange-900 mb-3">Co-Founder</p>
                                <p className="text-gray-600">Legal advocate committed to protecting children's rights
                                    and providing legal representation.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-16 px-4 bg-orange-900">
                    <div className="max-w-4xl mx-auto text-center">
                        <h4 className="text-4xl font-bold text-white font-heading mb-6">Join Us in Making a
                            Difference</h4>
                        <p className="font-semibold text-orange-100 mb-8 text-xl">Together, we can create a society of
                            justice and equity for our children.</p>

                    </div>
                </div>
            </div>
        </>

    )
}
export default About;